import type { AuthFormError } from '../types';
import { AuthAlert } from './auth-alert';

export function FormErrorAlert({ error }: { error: AuthFormError }) {
  return (
    <AuthAlert type="warning">
      {'errors' in error ? (
        Object.values(error.errors)
          .flat()
          .map((message) => (
            <p key={message} className="text-sm">
              {message}
            </p>
          ))
      ) : (
        <p className="text-sm">{error.message}</p>
      )}
    </AuthAlert>
  );
}
